module.exports = __webpack_public_path__ + "img/no-notes-state.8b4e472b.svg";